import { createSelector } from 'reselect';
import { folderPresenter } from '../common/folderPresenter';
import { getArmyListsState, getFolderIsLoading } from '../common/selector';
import { getArmyLists } from '../../myBuilder/selector';
import { AddArmyListView } from './view/AddArmyListView';
import { ArmyListView } from '../../myBuilder/show/view/ArmyListView';
import { getArmies } from '../../myArmyList/common/selector';

export const AddArmyListPresenter = createSelector(
  [
    folderPresenter,
    getFolderIsLoading,
    getArmyLists,
    getArmyListsState,
    getArmies,
  ],
  (
    folder,
    folderIsLoading,
    armyLists,
    armyListsIsLoading,
    armies,
  ): AddArmyListView => {
    return new AddArmyListView({
      armyLists: armyLists
        .filter((item) => item.folderId != folder.id)
        .map((item) => {
          const army = armies.find((a) => a.id === item.armyId);
          return new ArmyListView({
            id: item.id,
            name: item.name,
            initials: army?.initials ?? null,
            logo: army?.large_logo ?? null,
            versionColor: item.versionColor,
            versionName: item.versionName,
          });
        }),
      isLoading: folderIsLoading || armyListsIsLoading,
      canSubmit: !(folderIsLoading || armyListsIsLoading),
    });
  },
);
